import { makeStyles } from '@mui/styles';
import React from 'react';
import { useSelector } from 'react-redux';

import { getEntityFieldsTranslation } from '../selectors/report-designer.selectors';
import { getSimpleBlockTitle } from '../utils/report-designer.utils';

const useStyles = makeStyles({
  root: {
    padding: '0 4px',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const SSSimpleBlock = (props) => {
  const classes = useStyles();
  const entityFieldsTranslations = useSelector(getEntityFieldsTranslation);

  const title = getSimpleBlockTitle({ ...props, translations: entityFieldsTranslations });

  return <div className={classes.root}>{title}</div>;
};

export default SSSimpleBlock;
